import { Component, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { AuthService } from '../../auth.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { timer } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SelectCompanyOrgComponent } from '../select-company-org/select-company-org.component';

@Component({
  selector: 'app-login',
  templateUrl: `./login.component.html`,
  styleUrl: './login.component.scss',
})

export class LoginComponent implements OnInit {
  timeLeft: number = 900;
  interval: any;
  subscribeTimer: any;
  sessionExpiredMessage: string | null = null;
 loginForm = new FormGroup({
   userName: new FormControl(),
   passcode: new FormControl(),
 })

  forgetPasswordForm = new FormGroup({
    userName: new FormControl(),
    passcode: new FormControl(),
  })

  validateToken: any;
  showPasscode: boolean;

  constructor(private authService: AuthService, private route: ActivatedRoute,
    private router: Router, private _snackBar: MatSnackBar, private dialog: MatDialog) {
    
    this.authService.sessionExpired$.subscribe(() => {
      this.showSessionExpiredMessage();
    });
  }

  
  showSessionExpiredMessage() {
    this._snackBar.open('Session expired. Please log in again.', 'Close', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });

    
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 3000);  
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['message']) {
        this.sessionExpiredMessage = params['message'];
      }
    });

  }

  loginHere() {
    this.authService.auth(this.loginForm.controls['userName'].value).subscribe((response:any) => {
      if (!response.isError) {
        this.validateToken = response.value.token;
        this.timer()
        this.showPasscode = !this.showPasscode;
      } else {
        this._snackBar.open(response.value.value, 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
    }, (error) => {
      this._snackBar.open('Please verify your Email or Username, does not match our records.', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      
    });
  }

  timer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 60;
      }
    }, 1000)
  }

  validateLoginToken() {
    const input = {
      resetToken: this.validateToken,
      passCode: this.loginForm.controls['passcode'].value
    }
    this.authService.validateLogin(input).subscribe((response) => {
      const token = response.value;  
      this.authService.setToken(token);  
      if(response.isError){
        this._snackBar.open('Passcode is incorrect, please enter valid passcode', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      } else {
        
        if (token !== null) {
          
          this.authService.getDashboardScreenByOrg().subscribe((response) => {
            const companyId = localStorage.getItem('companyOrg');
            if (companyId === '3' || companyId === '7') {
              const modalRef = this.dialog.open(SelectCompanyOrgComponent, {
                height: "80%",
                width: "50%",
                maxWidth: "80%",
                maxHeight: "90%",
                panelClass: 'select-organisation-modal',
                data: response.value
              });
              modalRef.afterClosed().subscribe((result) => {
                this.router.navigate(['/components/Dashboard']).then(() => {
                  window.location.reload();
                });
              });
            } else {
              this.router.navigate(['/components/Dashboard']).then(() => {
                  window.location.reload();
                });
            }
          });
        } else {
          this._snackBar.open('Invalid Token', 'Close', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      }
    }, 
    );
  }
}

